import { render, staticRenderFns } from "./PaginateList.vue?vue&type=template&id=ec202dea&"
import script from "./PaginateList.vue?vue&type=script&lang=js&"
export * from "./PaginateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports